import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Input, UncontrolledTooltip } from 'reactstrap';

import { runFileAction } from '../../../actions/Mini';

import FileActions from '../File/Actions';
import FileDetails from '../../../components/File/Details';
import FileTitle from '../../../components/File/Title';

import { checkActionFileSupport } from '../../../helpers/Mini';
import { addSelectedFile, removeSelectedFile } from '../../../actions/Files';

const FilesMiniMasonryItem = (props) => {
  const {
    dispatch,
    data: {
      file,
      isSelected,
    },
    width,
    miniConfig,
    selectedFiles,
  } = props;

  const fileTo = {};

  let height;
  if (file.height) {
    height = (width / file.width) * file.height;
  }

  const handleThumbnailClick = (e) => {
    e.preventDefault();
    dispatch(runFileAction(file, null, 'thumbnail_click'));
  };

  const availableActions = miniConfig.actions.filter(action => (
    checkActionFileSupport(action, file).isSupported
  ));

  const allowMultiselect = miniConfig.supports?.includes('multiselect-files');

  const isFileSelected = selectedFiles.some(selectedFile => selectedFile.uuid === file.uuid);

  return (
    <div
      id={file.uuid}
      className={classnames('masonry-item', { 'masonry-item-selected': isFileSelected })}
    >
      <div className="masonry-item-header">
        <div className="masonry-item-header-inner">
          <div />
          {availableActions.length > 0 && allowMultiselect && (
            <Input
              type="checkbox"
              className="input-check check-m"
              id={`file-${file.uuid}`}
              checked={isSelected}
              onChange={() => {
                if (isSelected) {
                  dispatch(removeSelectedFile(file.uuid));
                } else {
                  dispatch(addSelectedFile(file));
                }
              }}
              aria-label={isSelected ? 'Unselect' : 'Select'}
            />
          )}
        </div>
      </div>
      <div id={`file-element-${file.uuid}`} className="masonry-item-wrapper">
        {file.type === 'link' ? (
          <a href={file.path} className="masonry-item-img-wrapper" title={file.display_name} target="_blank" rel="noopener noreferrer">
            <img
              className="masonry-item-img"
              width="100%"
              src={file.urls.thumbnailmasonry}
              alt={file.display_name}
              style={{
                width,
                height,
              }}
            />
          </a>
        ) : (
          <Link to={fileTo} onClick={handleThumbnailClick} className="masonry-item-img-wrapper">
            <img
              className="masonry-item-img"
              width="100%"
              src={file.urls.thumbnailmasonry}
              alt={file.display_name}
              style={{
                width,
                height,
              }}
            />
          </Link>
        )}
        <div className="masonry-item-body">
          <FileTitle
            className="masonry-item-title"
            file={file}
            fileTo={fileTo}
          />
          <FileDetails
            file={file}
            showAccess={false}
          />
          {availableActions.length === 0 && (
            <>
              <i className="far fa-triangle-exclamation" id={`file-${file.uuid}-unsupported`} />
              <UncontrolledTooltip fade={false} target={`file-${file.uuid}-unsupported`}>
                {miniConfig.integrationId === 'webflow' && 'This file type is not supported by Webflow'}
                {miniConfig.integrationId !== 'webflow' && checkActionFileSupport(miniConfig.actions[0], file).message}
              </UncontrolledTooltip>
            </>
          )}
        </div>
        <div className="masonry-item-body">
          <div className="masonry-item-actions">
            <FileActions
              file={file}
              availableActions={availableActions}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => ({
  selectedFiles: state.Files.selectedFiles,
  collection: state.Collections.collection,
  id: props.data.file.uuid,
  miniConfig: state.Mini.config,
});

FilesMiniMasonryItem.propTypes = {
  dispatch: PropTypes.func.isRequired,
  miniConfig: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  width: PropTypes.number.isRequired,
  selectedFiles: PropTypes.array.isRequired,
};

export default connect(mapStateToProps)(FilesMiniMasonryItem);
